import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from "reactstrap";

const BookingActivity = ({
  bookings = [],
}) => {

  const pending =
    bookings.filter(
      (x) =>
        x?.status?.toUpperCase() ===
        "PENDING"
    ).length;

  const cancelled =
    bookings.filter(
      (x) =>
        x?.status?.toUpperCase() ===
        "CANCELLED"
    ).length;

  const confirmed =
    bookings.filter(
      (x) =>
        x?.status?.toUpperCase() ===
        "CONFIRMED"
    ).length;

  const failed =
    bookings.filter(
      (x) =>
        x?.syncStatus?.toUpperCase() ===
        "FAILED"
    ).length;

  return (
    <Col xl={4}>
      <Card
        style={{
          height: "100%",
        }}
      >
        <CardHeader>
          <h4 className="card-title mb-0">
            Booking Activity
          </h4>
        </CardHeader>

        <CardBody>

          <Row className="g-3">

            <Col xs={6}>
              <div className="border rounded p-3 text-center">
                <h3 className="mb-1">
                  {bookings.length}
                </h3>
                <small className="text-muted">
                  Total Bookings
                </small>
              </div>
            </Col>

            <Col xs={6}>
              <div className="border rounded p-3 text-center">
                <h3 className="mb-1 text-warning">
                  {pending}
                </h3>
                <small className="text-muted">
                  Pending
                </small>
              </div>
            </Col>

            <Col xs={6}>
              <div className="border rounded p-3 text-center">
                <h3 className="mb-1 text-success">
                  {confirmed}
                </h3>
                <small className="text-muted">
                  Confirmed
                </small>
              </div>
            </Col>

            <Col xs={6}>
              <div className="border rounded p-3 text-center">
                <h3 className="mb-1 text-danger">
                  {cancelled}
                </h3>
                <small className="text-muted">
                  Cancelled
                </small>
              </div>
            </Col>

            <Col xs={12}>
              <div className="border rounded p-3 text-center">
                <h3 className="mb-1 text-danger">
                  {failed}
                </h3>
                <small className="text-muted">
                  Failed Syncs
                </small>
              </div>
            </Col>

          </Row>

        </CardBody>
      </Card>
    </Col>
  );
};

export default BookingActivity;